// extracted by mini-css-extract-plugin
export var content = "layout-module--content--b7272";
export var header = "layout-module--header--3c1a9";